import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoPrestacionJuicio, TipoPrestacionJuicioProps } from '../../interfaces/catalogos/TipoPrestacionJuicioInterface';
import { TipoPrestacionProps } from '../../interfaces/catalogos/TipoPrestacionInterface';

export const TiposPrestacionesJuicio = () => {

    return new Promise<TipoPrestacionJuicioProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoPrestacionJuicio/', token)
            .then( ({ data } : { data : TipoPrestacionJuicioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ObtenerTipoPrestacionJuicios = () => {

    return new Promise<TipoPrestacionJuicioProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoPrestacionJuicio/ObtenerTipoPrestacionJuicios', token)
            .then( ({ data } : { data : TipoPrestacionJuicioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ObtenerTipoPrestacionPorJuicio = ( id: number ) => {

    return new Promise<TipoPrestacionProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/TipoPrestacionJuicio/ObtenerTipoPrestacionPorJuicio/${ id }`, token)
            .then( ({ data } : { data : TipoPrestacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ActualizarTipoPrestacionJuicio = ( params: TipoPrestacionJuicioProps ) => {

    return new Promise<TipoPrestacionJuicioProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoPrestacionJuicio/Actualizar', params, token)
            .then( ({ data } : { data : TipoPrestacionJuicioProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoPrestacionJuicio } );
            });

        }

    });

}

export const AgregarTipoPrestacionJuicio = ( params: TipoPrestacionJuicioProps ) => {

    return new Promise<TipoPrestacionJuicioProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoPrestacionJuicio/Agregar', params, token)
            .then( ({ data } : { data : TipoPrestacionJuicioProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoPrestacionJuicio } );
            });

        }

    });

}
